import moonCoffee from "../../clients/moon-coffee.json";

// Future automation only needs to generate a JSON file and change this import.
export const currentClientData: unknown = moonCoffee;
